
import TextResources from '../../Resources/TextResources';

function TimelineContainer(props) {
    const tl_num = props.tl_id;
    const tl_id_val = "tl-" + tl_num;
    const textResource_i = "timeline_" + tl_num;
    const { changeDesc } = props;

    return(
        <div className='dot-container' id={tl_id_val}>
            <div className='timeline-label hind-mysuru-medium light-black-text'>{TextResources[textResource_i]["heading"]}</div>
            <button onClick={() => changeDesc(textResource_i)} className='timeline-dot'></button>
            <div className={`clickMe ${(props.nextUp === textResource_i) ? "clickMe-animate" : "hidden"}`}>
                <div className="d-flex flex-column align-items-center">
                    <div class="chevron-up"></div>
                    
                </div>
            </div>
        </div>
    )
}

export default TimelineContainer;